module.exports = __webpack_public_path__ + "static/img/pop_bg_coupon_clip_type2.ed1ca3df.png";